import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "FintechOmni";
const SITE_URL = "https://fintechomni.com";
const DEFAULT_TITLE = "FintechOmni — Private events for fintech marketers";
const DEFAULT_DESC = "Private, invite-only gatherings for the operators running performance marketing in fintech. No stage. No speakers. Just the room.";
const DEFAULT_OG = `${SITE_URL}/og-default.jpg`;

const ensureAbs = (url) => {
  if (!url) return DEFAULT_OG;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${SITE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
};

export const Seo = ({
  title,
  description,
  path = "",
  image,
  type = "website",
  noindex = false,
  jsonLd,
  keywords,
  publishedAt,
  updatedAt,
  author,
}) => {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`.replace(/\/$/, "") || SITE_URL;
  const ogImage = ensureAbs(image);

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      {noindex ? (
        <meta name="robots" content="noindex,nofollow,noarchive" />
      ) : (
        <meta name="robots" content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1" />
      )}
      {noindex && <meta name="referrer" content="no-referrer" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_US" />
      {publishedAt && <meta property="article:published_time" content={publishedAt} />}
      {updatedAt && <meta property="article:modified_time" content={updatedAt} />}
      {author && <meta property="article:author" content={author} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@fintechomni" />
      <meta name="twitter:creator" content="@fintechomni" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default Seo;
